// extracted by mini-css-extract-plugin
export default {"container":"Section03_container__mKTT2","Image":"Section03_Image__IYaNG","Graph":"Section03_Graph__oCakZ","Figures":"Section03_Figures__Me4Tm"};